import requests from './requests';

export default {
    login(payload) {
        const { phone, smsCode } = payload;

        return requests
            .post('/coach/login', {
                phone,
                sms_code: smsCode,
            })
            .then(resp => resp.data);
    },
    get() {
        return requests
            .get('/coach/coach')
            .then(resp => resp.data);
    },
    patch(payload) {
        return requests
            .patch('/coach/coach', payload)
            .then(resp => resp.data);
    },
    patchPhone(payload) {
        return requests
            .patch('/coach/coach/phone', payload)
            .then(resp => resp.data);
    },
    wechatBind(payload) {
        return requests
            .patch('/coach/coach/wechat_bind', { openid: payload.openid })
            .then(resp => resp.data);
    },
    wechatUnbind() {
        return requests
            .patch('/coach/coach/wechat_unbind')
            .then(resp => resp.data);
    },
    getAvailableDates(date) {
        return requests
            .get(`/coach/coach/available_dates/${date}`)
            .then(resp => resp.data);
    },
    getAvailableTimes(date) {
        return requests
            .get(`/coach/coach/available_times/${date}`)
            .then(resp => resp.data);
    },
};



// WEBPACK FOOTER //
// ./src/api/coach.js